<!-- По завершению анимации диспатчить событие big-win-finished. И по событию из стэйта bigWin переходить в стэйт game -->

<script>
    import { scale } from 'svelte/transition';
    import { onDestroy, onMount } from 'svelte';
    import { Rive, Layout, Fit, Alignment } from '@rive-app/canvas';
    import { RIVE_ANIMATIONS, getAnimationParams } from '@src/utils/animations.js';
    import { EventEmitterInstance } from '@root/src/utils/event-emitter';

    export let animationTypeOrderIndex;
    export let duration;

    const customDPR = 1;

    let animation = null;
    let animationParams = null;
    let stateMachineName = 'State Machine_all';
    let artBoard = 'ccc_wins';
    let winTriggerName = 'win_trigger';
    let pendingAnimationChanges = 0;

    let timer = null;
    let canvas;

    function dispatchFinish() {
        EventEmitterInstance.emit('big-win-finished');
    }

    onMount(() => {
        animation = new Rive({
            src: RIVE_ANIMATIONS.WIN,
            artboard: artBoard,
            canvas,
            autoplay: true,
            stateMachines: stateMachineName,
            layout: new Layout({
                fit: Fit.Cover,
                alignment: Alignment.Center
            }),
            onLoad: () => {
                animation.resizeDrawingSurfaceToCanvas(customDPR);
                animationParams = getAnimationParams(animation, stateMachineName, [winTriggerName]);

                timer = setTimeout(dispatchFinish, duration * 1000);
            },
            onStateChange: event => {
                // because of strange state machine we can fire animation changing only from 'loop' state
                if (event?.data?.[0]?.match(/loop/) && pendingAnimationChanges < animationTypeOrderIndex) {
                    animationParams[winTriggerName].fire();
                    pendingAnimationChanges++;
                }
            }
        });
    });

    onDestroy(() => {
        EventEmitterInstance.removeListener('big-win-finished');
        window.__assets_cache.audio_gameplay.volume(0.3);
        clearTimeout(timer);
    });

    // TODO play audio for tiers
    // const playAudioForAnimation = animationIndex => {
    //     const audioMapping = {
    //         0: window.__assets_cache.audio_win_default,
    //         1: window.__assets_cache.audio_win_big,
    //         2: window.__assets_cache.audio_win_super,
    //         3: window.__assets_cache.audio_win_epic,
    //         4: window.__assets_cache.audio_win_mega
    //     };
    //     const selectedAudio = audioMapping[animationIndex] || window.__assets_cache.audio_win_default;
    //     window.__assets_cache.audio_gameplay.volume(0);
    //     selectedAudio.on('end', () => {
    //         window.__assets_cache.audio_gameplay.volume(0.3);
    //     });
    // };
</script>

<div class="relative h-full w-full" out:scale>
    <canvas id="canvas" width="500" height="500" bind:this={canvas} class="h-full w-full bg-transparent" />
    <slot />
</div>
